<template>
  <div id="app">
    <div class="menu-info-box">
      <div @click="choice(1)" :class="(index === 1) ? 'choice' : ''">หน้าแรก</div>
      <div @click="choice(2)" :class="(index === 2) ? 'choice' : ''">ขั้นตอนการใช้งาน</div>
      <div @click="choice(3)" :class="(index === 3) ? 'choice' : ''">จุดเด่นของเรา</div>
      <div @click="choice(4)" :class="(index === 4) ? 'choice' : ''">นโยบายความเป็นส่วนตัว</div>
      <div @click="choice(5)" :class="(index === 5) ? 'choice' : ''"> ติดต่อเรา</div>
      <!-- <div @click="choice(6)" :class="(index === 6)?'choice':''">Contact Us</div> -->
    </div>
    <div class="home" ref="home">
      <img src="./assets/banner.png" class="banner">
      <div class="home-name-info-box">
        <div class="home-name">
          <p> ไม่มีหลักประกัน ดอกเบี้ยต่ำ สินเชื่อออนไลน์</p>
          <!-- <p> pinjaman profesional</p> -->
        </div>
        <!-- <a href="https://play.google.com/store/apps/details?id=com.uang.belanja">
          <img src="./assets/Google play.png" class="google-play">
        </a> -->
      </div>
    </div>
    <div class="step-db-box" ref="step">
      <div class="step-db-title">ขั้นตอนการใช้งาน</div>
      <div class="step-info-content">
        <div class="step-db-item-box-db">
          <div class="step-db-item">
            <img src="./assets/step-1.png" alt="">
            <p>1. ดาวน์โหลดแอพพลิเคชันกู้ให้ดีๆ</p>
          </div>
          <div class="step-db-item">
            <img src="./assets/step-3.png" alt="">
            <p>3. เลือกผลิตภัณฑ์สินเชื่อที่คุณชื่นชอบ</p>
          </div>
        </div>
        <div class="step-db-item-box-db">
          <img src="./assets/index.png" alt="">
        </div>
        <div class="step-db-item-box-db">
          <div class="step-db-item">
            <img src="./assets/step-2.png" alt="">
            <p>2. กรอกข้อมูลส่วนตัวให้ครบถ้วน</p>
          </div>
          <div class="step-db-item">
            <img src="./assets/step-4.png" alt="">
            <p>4. ชำระเงินกู้อย่างตรงเวลา จะสามารถเพิ่มวงเงินกู้ครั้งต่อไปได้</p>
          </div>
        </div>
      </div>
    </div>
    <div class="product-db-box" ref="product">
      <div class="step-db-title">จุดเด่นของเรา</div>
      <div class="product-db-content">
        <div class="product-db-img"><img src="./assets/product.png"></div>
        <div class="product-db-info-db-box">
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">1</div>
            </div>
            <div class="text">เป็นผลิตภัณฑ์สินเชื่อที่คัดสรรมาอย่างดี</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">2</div>
            </div>
            <div class="text">สมัครผลิตภัณฑ์สินเชื่อได้หลายรายการเพียงแค่คลิกเดียว</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">3</div>
            </div>
            <div class="text">ตอบโจทย์ความต้องการต่างๆ ในชีวิตและการทำงาน</div>
          </div>
          <div class="product-db-info">
            <div class="circular-db-box">
              <div class="circular">4</div>
            </div>
            <div class="text">ข้อมูลส่วนบุคคลจะเก็บเป็นความลับอย่างเข้มงวด</div>
          </div>

        </div>
      </div>
    </div>
    <div class="privacy-db-box" ref="privacy">
      <div class="step-db-title">นโยบายความเป็นส่วนตัว</div>
      <div class="privacy-content" :class="(isMore) ? '' : 'maxhight'">
        <br> ยืมเงินอย่างสุข นโยบายความเป็นส่วนตัวของ จัดทำขึ้นเพื่อแจ้งให้ผู้ใช้ทราบว่าเมื่อมีการใช้งานแอปพลิเคชัน ทางเราได้มีการรวบรวม ประมวลผล และปกป้องข้อมูลส่วนบุคคลและข้อมูลอื่น ๆ ของคุณอย่างไรเมื่อใช้ผลิตภัณฑ์และบริการของทางเรา
        <br> ผู้พัฒนาแอปพลิเคชัน ยืมเงินอย่างสุข คือ Jeffery Quirozs เมื่อมีการใช้งานแอปพลิเคชัน ผู้ใช้ยินยอมการจัดเก็บข้อมูลที่ได้กล่าวไปแล้วในข้างต้นในนโยบายความเป็นส่วนตัว ทั้งนี้รวมถึงการเปิดเผยข้อมูลต่าง ๆ และนโยบายการใช้งานอื่น ๆ และเพื่อการไม่หยุดพัฒนาในด้านการบริการ ดังนั้นทางเราจะมีการทำการปรับปรุงนโยบายความเป็นส่วนตัวเป็นระยะ ทางเราจึงขอแนะนำให้คุณทบทวนนโยบายความเป็นส่วนตัวนี้เป็นประจำ
        <br> ทั้งนี้เพื่อให้เป็นไปตามกฎหมายที่บังคับใช้ได้กำหนดให้ทางเราต้องเปิดเผยข้อมูลแก่บุคคลที่สามที่ได้รับอนุญาต (เช่น รัฐบาล) เฉพาะเมื่อศาลออกคำสั่งทางกฎหมายเท่านั้น ทั้งนี้ก็เช่นเดียวกับธนาคารที่เกี่ยวข้องและสถาบันการเงินอื่น ๆ
        <br> ทางเราให้ความสำคัญอย่างยิ่งต่อความเป็นส่วนตัวของผู้ใช้และโปรดอ่านนโยบายต่อไปนี้อย่างละเอียด

        <h3> ข้อมูลส่วนบุคคลที่รวบรวม</h3>
        - ข้อความ SMS พื่อให้มั่นใจในความปลอดภัยของเงินทั้งสองฝ่าย เมื่อผู้ใช้ขอสินเชื่อ ยืมเงินอย่างสุข จำเป็นต้องได้รับข้อมูล SMS ของผู้ใช้ (รวมถึง: ชื่อข้อความ เนื้อหาข้อความ ว่าจะอ่านหรือไม่) เพื่อประเมินคุณค่าของผู้ใช้และ ทำการวิเคราะห์ป้องกันการฉ้อโกง ข้อมูล SMS ที่รวบรวมจะถูกเข้ารหัสและอัปโหลดไปที่ https://qc .qbkwhitll.com/qq-gp และจะไม่ถูกแชร์กับบุคคลที่สาม
        <br> -ข้อมูลรายชื่อผู้ติดต่อ เมื่อผู้ใช้ยืมเงินอย่างสุขสมัครสินเชื่อ ยืมเงินอย่างสุข จะกำหนดให้ผู้ใช้กรอกและเลือกข้อมูลติดต่อฉุกเฉินรายการ (ได้แก่ เบอร์ติดต่อ ชื่อผู้ติดต่อ ความสัมพันธ์) จากสมุดที่อยู่เพื่อวิเคราะห์ ป้องกันการฉ้อโกงและประเมินอันดับเครดิตของผู้ใช้ได้ดีขึ้น ข้อมูลติดต่อที่รวบรวมได้จะถูกเข้ารหัสและอัปโหลดไปที่ https://qc.qbkwhitll.com/qq-gp หากผู้ใช้ปิดหรือถอนการติดตั้งแอปพลิเคชันนี้จะไม่มีการรวบรวมข้อมูล ข้อมูลที่รวบรวมจะไม่ถูกเปิดเผยต่อบุคคลที่สาม
        <br> -ข้อมูลประวัติการโทร เมื่อผู้ใช้ลงทะเบียนหรือเข้าสู่ระบบด้วยรหัสยืนยันด้วยเสียงที่ ยืมเงินอย่างสุข ยืมเงินอย่างสุข จำเป็นต้องได้รับข้อมูลบันทึกการโทรของผู้ใช้ (รวมถึง: หมายเลข ระยะเวลา ประเภทการโทร ฯลฯ) เพื่อยืนยันโทรศัพท์มือถือ ที่ผู้ใช้ลงทะเบียนและได้รับรหัสยืนยัน การ์ดและอุปกรณ์อยู่ด้วยกันเพื่อยืนยันว่าดำเนินการโดยผู้ใช้เอง เพื่อป้องกันไม่ให้ผู้ใช้ถูกขโมยโดยฉ้อโกง ข้อมูลติดต่อที่รวบรวมได้จะถูกเข้ารหัสและอัปโหลดไปที่ https://qc.qbkwhitll.com/qq-gp หากผู้ใช้ปิดหรือถอนการติดตั้งแอปพลิเคชันนี้จะไม่มีการรวบรวมข้อมูล ข้อมูลที่รวบรวมจะไม่ถูกเปิดเผยต่อบุคคลที่สาม
        <br> -ข้อมูลบัญชีโซเชียล เรารวบรวมข้อมูลบัญชีโซเชียลของคุณ (เช่น อีเมล Gmail, บัญชี Facebook) เพื่อรักษาความสัมพันธ์ที่ดีกับผู้ใช้ ดำเนินการวิจัย และกลับไปเยี่ยมชมประสบการณ์ผู้ใช้ของแอปพลิเคชัน ข้อมูลที่รวบรวมจะถูกอัปโหลดไปที่ https://qc.qbkwhitll.com/qq-gp เพื่อปกป้องความปลอดภัยของข้อมูลของคุณ
        <br> - ข้อมูลส่วนบุคคล เมื่อคุณลงทะเบียนบัญชี ยืมเงินอย่างสุข ทางเราจำเป็นต้องรวบรวมข้อมูลส่วนบุคคลของคุณ เช่น ชื่อ-นามสกุล ข้อมูลบนบัตรประชาชน อีเมล และหมายเลขโทรศัพท์
        <br> -ที่ตั้ง เมื่อผู้ใช้ยืมเงินอย่างสุข พวกเขาจำเป็นต้องได้รับตำแหน่งทางภูมิศาสตร์คร่าวๆ สำหรับการแนะนำผลิตภัณฑ์ในระดับภูมิภาค
        <br> - รายการแอปพลิเคชันที่ติดตั้งแล้ว จำเป็นต้องรวบรวมข้อมูลแอปพลิเคชันที่ติดตั้งของผู้ใช้เพื่อประเมินระดับการเงินของผู้ใช้และปกป้องความปลอดภัยทางการเงินของผู้ใช้
        <br> - ข้อมูลทางการเงิน เมื่อคุณติดตั้งแอปพลิเคชัน ยืมเงินอย่างสุข ทางเราจะขอให้คุณระบุข้อมูลธนาคารเพื่อตรวจสอบข้อมูลทางการเงินของคุณ
        <br> - การบันทึกข้อมูล เมื่อคุณใช้บริการของทางเรา ทางเราจะบันทึกข้อมูลการใช้งานของคุณโดยอัตโนมัติ

        <h3>จุดประสงค์ของการเก็บและรวบรวมข้อมูลส่วนบุคคล</h3>
        - เพื่อเป็นการยืนยันตัวตนและเพื่อให้แน่ใจว่าจะไม่ใช่บุคคลที่ไม่ได้รับอนุญาตลงชื่อเข้าใช้บัญชีส่วนตัวของคุณ
        <br> - เพื่อเป็นการยืนยันการขอสินเชื่อ
        <br> - เพื่อปรับปรุงประสิทธิภาพการบริการโปรดระบุอุปกรณ์ของคุณ
        <br> - เพื่อตรวจสอบการฉ้อโกงทางการเงิน
        <br> - เพื่อหลีกเลี่ยงความเสี่ยงจากการทุจริตที่อาจจะเกิดขึ้นได้
        <br> - เพื่อการวิเคราะห์ข้อมูลและปรับปรุงการบริการ
        <br> - เพื่อการปรับปรุงประสบการณ์บนผลิตภัณฑ์ของคุณ

        <h3> การนำข้อมูลส่วนบุคคลไปใช้</h3>
        - ตามเงื่อนไขการใช้บริการและสัญญาการให้บริการ
        <br> - ตามกฎหมายและระเบียบที่เกี่ยวข้อง ซึ่ง ยืมเงินอย่างสุข จะไม่จัดหา ขาย ให้เช่า แบ่งปันหรือแลกเปลี่ยนข้อมูลส่วนบุคคลของผู้ใช้กับบุคคลที่สามที่ไม่เกี่ยวข้อง

        <h3>การแบ่งปันข้อมูลส่วนบุคคล</h3>
        ทางเราอาจจะส่งข้อมูลส่วนบุคคลให้แก่บุคคลที่สามหรือบริษัทในเครือเพื่อความจำเป็นเท่านั้น และในกรณีต่อไปนี้ ทางเราอาจจะต้องส่งข้อมูลส่วนบุคคลให้แก่หน่วยงานของรัฐ ศาล หรือหน่วยงานรัฐบาลอื่นๆ ดังนี้ 1. เมื่อได้รับอนุญาตหรือมีความจำเป็นตามกฎหมาย 2. เพื่อป้องกันหรือป้องกันการฉ้อโกงหรือธุรกรรมที่ไม่ได้รับอนุญาตที่เกิดขึ้นหรืออาจจะเกิดขึ้น 3. เพื่อตรวจสอบการทุจริตหรือสงสัยว่ามีการฉ้อโกงเกิดขึ้น
        <br> หากยังไม่ได้รับความยินยอมจากผู้ใช้ อาจจะมีการให้ข้อมูลส่วนบุคคลข้างต้น และหากคุณขอสละสิทธิ์การเรียกร้องหรือความสูญเสียทั้งหมดของทางเราที่เกี่ยวข้องกับการเปิดเผยข้อมูลส่วนบุคคลในที่นี้ นโยบายความเป็นส่วนตัวนี้มีผลผูกพันกับทางเราและผู้ใช้ และมีผลผูกพันกับบุคคลที่สามอื่น ๆ (แต่ไม่จำกัดเฉพาะผู้ให้บริการ) ผู้ใช้เข้าใจว่าบุคคลที่สามมีนโยบายความเป็นส่วนตัวของตนเองเกี่ยวกับการใช้และการประมวลผลข้อมูลส่วนบุคคล นอกเหนือจากเงื่อนไขข้างต้นแล้ว ทางเราจะขอความยินยอมจากผู้ใช้เพื่อแบ่งปันข้อมูลส่วนบุคคลของคุณกับผู้อื่น ภายใต้เงื่อนไขของการได้รับอนุญาตอย่างชัดแจ้งจากผู้ใช้ ข้อมูลส่วนบุคคลของคุณจะถูกเข้ารหัสและส่งไปยัง https://qc.qbkwhitll.com/qq-gp ทางเราจะไม่ขาย ให้ยืม หรือให้เช่าข้อมูลส่วนบุคคลใด ๆ ของคุณ

        <h3> การจัดเก็บ ดูแล และการลบข้อมูล</h3>
        ข้อมูลส่วนบุคคลของคุณและข้อมูลที่เกี่ยวข้องอื่น ๆ จะถูกส่งและจัดเก็บผ่านเทคโนโลยีการเข้ารหัส (SSL) ที่ทั้งการส่งและการจัดเก็บล้วนได้รับการป้องกันด้วยรหัสผ่านทั้งสิ้น ในขณะเดียวกันทางเรายังมีกลไกการป้องกันต่าง ๆ เพื่อปกป้องข้อมูลส่วนบุคคลของคุณจากการโจมตีที่เป็นอันตราย ตราบใดที่บัญชีของคุณยังมีการเคลื่อนไหว ทางเราจะเก็บรักษาข้อมูลส่วนบุคคลและสามารถลบได้ตามกฎหมายที่บังคับใช้

        <h3>การประกันการปฏิบัติตามกฎระเบียบ</h3>
        ทางเราขอประกาศและรับรองไว้ ณ ที่นี้ว่าทางเราได้ปฏิบัติตามกฎหมายและระเบียบข้อบังคับของประเทศไทยเกี่ยวกับการคุ้มครองข้อมูลส่วนบุคคล

        <h3>การเปลี่ยนแปลงนโยบายความเป็นส่วนตัว</h3>
        นโยบายความเป็นส่วนตัวของทางเราอาจจะมีการเปลี่ยนแปลงตามสถานการณ์ปัจจุบัน โดยที่ทางเราจะแจ้งให้ผู้ใช้ทราบทุกครั้งที่มีการเปลี่ยนแปลง และหากมีการเข้าถึงหรือใช้บริการของทางเราต่อไปจะถือว่าผู้ใช้ยอมรับการเปลี่ยนแปลงในนโยบายความเป็นส่วนตัว

        <h3>ช่องทางการติดต่อ</h3>
        หากคุณมีคำถามใด ๆ เกี่ยวกับนโยบายความเป็นส่วนตัวนี้ สามารถติดต่อทางเราได้ที่
        <br> อีเมล: hdoqwhioh34d@gmail.com
      </div>
      <div class="zkmore" @click="isMore = !isMore" v-if="!isMore">
        <img src="./assets/open.png" class="open">
      </div>
    </div>
    <div class="footer-db-box" ref="footer">
      <div class="step-db-title">ติดต่อเรา</div>
      <div class="footer-dbcontent">
        <div class="text">กู้ให้ดีๆ เป็นผู้ให้บริการสินเชื่อส่วนบุคคลชั้นนำ มุ่งมั่นที่จะให้บริการสินเชื่อออนไลน์ที่ไม่มีหลักประกัน มีประสิทธิภาพสูง และดอกเบี้ยต่ำแก่ผู้กู้ยืม ทางเราสามารถให้ผลิตภัณฑ์สินเชื่อมูลค่าสูงถึง 20,000 บาท ที่สำคัญใช้เพียงบัตรประจำตัวประชาชนใบเดียวก็สามารถลงทะเบียนสินเชื่อ รวมถึงกระทำกระบวนการทั้งหมดไม่ว่าจะเป็นการกู้ยืมหรือการชำระคืนเงินกู้ ในเวลาเดียวกัน ข้อมูลส่วนบุคคลของผู้ใช้งานจะได้รับการป้องกันอย่างเข้มงวดที่สุดจากทางเรา และจะทำให้ผู้ใช้งานได้รับประสบการณ์การกู้ยืมที่ดีที่สุด</div>
        <div class="footer-db-info">
          <div class="mail-db-box">
            <img src="./assets/mail.png" class="mail-img">
            <div class="mail">hdoqwhioh34d@gmail.com</div>
          </div>
          <div class="address-db-box">
            <img src="./assets/address.png" class="address-img">
            <div class="address">
              3445 อาคารเอ็นมาร์คพลาซ่า ถนนลาดพร้าว แขวงคลองจั่น เขตบางกะปิ กรุงเทพมหานคร 10240
            </div>
          </div>
        </div>
        <div class="bottom-text">
          Copyright 2022. กู้ให้ดีๆ all Rights Reserved.
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'App',
  data() {
    return {
      isMore: false,
      index: 1,
      isScroll: false
    }
  },
  mounted() {
    this.$nextTick(() => {
      window.addEventListener("scroll", (el) => {
        if (this.isScroll) {
          return
        }
        let homeRect = this.$refs.home.getBoundingClientRect()
        let stepRect = this.$refs.step.getBoundingClientRect()
        let productRect = this.$refs.product.getBoundingClientRect()
        // let userRect = this.$refs.user.getBoundingClientRect()
        let privacyRect = this.$refs.privacy.getBoundingClientRect()
        let footerRect = this.$refs.footer.getBoundingClientRect()

        if (homeRect.top <= 0 && homeRect.bottom > 0) {
          console.log('homeRect');
          this.index = 1
        }
        if (stepRect.top <= 0 && stepRect.bottom > 0) {
          console.log('step');
          this.index = 2
        }
        if (productRect.top <= 0 && productRect.bottom > 0) {
          console.log('step');
          this.index = 3
        }
        // if (userRect.top <= 0 && userRect.bottom > 0) {
        //   console.log('step');
        //   this.index = 4
        // }
        if (privacyRect.top <= 0 && privacyRect.bottom > 0) {
          console.log('step');
          this.index = 4
        } if (footerRect.top <= 0 && footerRect.bottom > 0) {
          console.log('step');
          this.index = 5
        }
      })
    })
  },
  methods: {
    choice(value) {
      this.isScroll = true
      this.index = value
      switch (value) {
        case 1: this.$refs.home.scrollIntoView(); break;
        case 2: this.$refs.step.scrollIntoView(); break;
        case 3: this.$refs.product.scrollIntoView(); break;
        // case 4: this.$refs.user.scrollIntoView(); break;
        case 4: this.$refs.privacy.scrollIntoView(); break;
        case 5: this.$refs.footer.scrollIntoView(); break;
        default:
          break;
      }
      this.$nextTick(() => {
        setTimeout(() => {
          this.isScroll = false
        }, 500);
      })
    }
  }
}
</script>
<style lang="less">
* {
  margin: 0;
  padding: 0;
}

body {
  margin: 0;
  padding: 0;
  width: 100%;
  font-family: Microsoft YaHei, Hiragino Sans GB, sans-serif;
}

li {
  list-style-type: none;
  list-style-position: outside;
}

.menu-info-box {
  position: fixed;
  top: 0px;
  left: 0;
  background-color: #6c5df3;
  width: 100%;
  display: flex;
  height: 80px;
  align-items: center;
  font-size: 18px;
  color: #ffffff;
  justify-content: flex-end;
  z-index: 10;

  div {
    margin-right: 62px;
    cursor: grab;
  }

  .choice {
    height: 34px;
    background: #fbd657;
    border-radius: 17px;
    padding: 0px 20px;
    color: #6c5df3;
    line-height: 34px;
  }
}

@media only screen and (max-width: 1200px) {
  .menu-info-box {
    display: none;
  }
}
</style>

<style lang="less" scoped>
.home {
  .banner {
    width: 100%;
  }

  .home-name-info-box {
    font-size: 46px;
    color: #ffffff;
    text-align: left;
    position: absolute;
    left: 150px;
    top: 434px;
    display: grid;

    .google-play {
      width: 376px;
      margin-top: 60px;
    }
  }
}

.step-db-box {
  padding-top: 180px;

  .step-db-title {
    text-align: center;
    position: relative;
    font-size: 40px;
  }

  .step-info-content {
    margin-top: 100px;
    display: flex;
    justify-content: space-evenly;
    align-items: center;
    text-align: center;

    .step-db-item-box-db {
      width: 1800px;

      img {
        width: 400px;
      }

      .step-db-item {
        padding: 60px 20px;
        text-align: center;

        img {
          width: 96px;
        }

        p {
          margin-top: 22px;
          padding: 0px 150px;
          font-size: 18px;
          text-align: left;
          margin-left: 30px;
          color: #333;
        }
      }
    }
  }
}

.product-db-box {
  padding-top: 180px;

  .step-db-title {
    text-align: center;
    position: relative;
    font-size: 40px;
  }

  .product-db-content {
    margin-top: 130px;
    padding: 0px 180px 0px 180px;
    display: flex;
    align-items: center;
    justify-content: space-evenly;

    .product-db-img {
      img {
        width: 485px;
      }
    }

    .product-db-info-db-box {
      .product-db-info {
        display: flex;
        margin-top: 50px;
        align-items: center;

        .circular-db-box {
          width: 40px;
          height: 40px;
          background: rgba(108, 93, 243, 0.3);
          box-shadow: 0 2px 20px 0 #c6a7ff;
          border-radius: 20px;

          .circular {
            margin: 5px;
            width: 30px;
            height: 30px;
            background: #6c5df3;
            border-radius: 15px;
            font-size: 16px;
            color: #ffffff;
            text-align: center;
            line-height: 30px;
          }
        }

        .text {
          font-size: 24px;
          margin-left: 20px;
        }
      }
    }
  }
}

.privacy-db-box {
  padding-top: 180px;

  .step-db-title {
    text-align: center;
    position: relative;
    font-size: 40px;
  }

  .maxhight {
    max-height: 460px;
    overflow: hidden;
  }

  .privacy-content {
    margin-top: 130px;
    padding: 0px 150px;
    color: #304380;

    font-size: 26px;
    text-align: left;
    line-height: 50px;

    h3 {
      font-weight: bold;
      line-height: 1.5;
      color: #3c529b;
    }

    .text {
      font-size: 26px;
      color: #3c529b;
      text-align: left;
      line-height: 50px;
      text-indent: 0.2rem;

      span {
        font-weight: bold;
      }
    }
  }

  .zkmore {
    height: 150px;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 46px;
    color: #304380;

    .open {
      width: 70px;
      height: 70px;
    }
  }
}

.footer-db-box {
  margin-top: 50px;
  padding-top: 80px;
  background: #333;

  .step-db-title {
    text-align: center;
    position: relative;
    font-size: 40px;
    color: #ffffff;
  }

  .footer-dbcontent {
    padding: 0px 120px;

    .text {
      color: #fff;
      font-size: 18px;
      margin-top: 20px;
      text-align: center;
    }

    .footer-db-info {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-top: 80px;

      .mail-db-box {
        max-width: 45%;
        display: flex;
        align-items: center;

        .mail-img {
          width: 33px;
        }

        .mail {
          font-size: 18px;
          color: #ffffff;
          margin-left: 17px;
        }
      }

      .address-db-box {
        max-width: 45%;
        display: flex;
        align-items: center;

        .address-img {
          width: 28px;
        }

        .address {
          font-size: 18px;
          color: #ffffff;
          margin-left: 17px;
          text-align: left;
        }
      }
    }

    .bottom-text {
      margin-top: 50px;
      padding-bottom: 100px;
      font-size: 16px;
      text-align: center;
      color: #fff;
    }
  }
}
</style>
